import html from "nanohtml";
import { cva } from "class-variance-authority";
import type { Post, Event } from "../../types.ts";
import { ASPECT_RATIOS } from "../../utils/imageUtils.ts";
import { A11Y } from "../../utils/constants.ts";
import { ResponsiveImage } from "./responsiveImage.ts";
import { Link } from "./link.ts";

interface ArticleCardHorizontalV2Props extends Post {
  logger: (event: Event) => void;
  hasBorder?: boolean;
  size?: "small" | "large";
}

export function ArticleCardHorizontalV2(
  props: ArticleCardHorizontalV2Props
): HTMLElement {
  return Link(
    {
      href: props.url,
      className: "rw-group rw-focus:outline-none text-blue",
      logger: props.logger,
      articleId: props.id,
    },
    html`
      <div class="rw-flex rw-items-start rw-gap-3 rw-hover:bg-gray-100 rw-transition-colors rw-duration-200">
        <div
          class="rw-flex-shrink-0 rw-overflow-hidden rw-bg-gray-200 rw-w-32 rw-h-32 rw-rounded-md"
          role="img"
          aria-label="Article image"
        >
          ${ResponsiveImage({
            path: props.coverImage.path,
            fallbackUrl: props.coverImage.url,
            aspectRatio: ASPECT_RATIOS.square,
            alt: props.title,
            className: "rw-w-full rw-h-full rw-object-cover",
          })}
        </div>
        <div class="rw-flex-1 rw-min-w-0">
          <h3
            class="rw-title-font rw-my-0 rw-text-base rw-line-clamp-4"
            aria-label="Article title"
          >
            ${props.title}
          </h3>
          <span class="${A11Y.SCREEN_READER_ONLY}">
            Published by ${props.author} on
            ${new Date(props.updatedAt).toLocaleDateString()}
          </span>
        </div>
      </div>
    `
  );
}
